import React, { useState } from 'react';
import DualTimeline from '../TimeLine/DualTimeline';
import './About3.css';

const About3 = (props) => {

    const [open, setOpen] = React.useState(false);

    function handleClose() {
        setOpen(false);
    }

    const [state, setState] = useState({
    })

    const handleClickOpen = (item) => {
        setOpen(true);
        setState(item)
    }

    return (
        <section className="wpo-about-section-s3" id='about'>
            <section className="timeline-section">
                <div className="container">
                    <DualTimeline />
                </div>

            </section>
        </section>

    );
};

export default About3;